import { keepPreviousData, queryOptions } from "@tanstack/react-query"
import { z } from "zod"
import { PROJECT_STATUSES } from "@/features/project-status/core/projectStatus"
import { reportsQueryKeys } from "@/lib/queryKeys"
import {
  getShallowShelvesReport,
  type ShallowShelvesParams,
} from "../../server/shallowShelvesServer"

export const ShallowShelvesSearchParams = z.object({
  status: z.enum(PROJECT_STATUSES).optional(),
  countryCodes: z.array(z.string()).optional(),
  pageIndex: z.coerce.number().int().min(0).optional(),
  pageSize: z.coerce.number().int().min(1).max(200).optional(),
})

export type ShallowShelvesSearchValues = z.infer<typeof ShallowShelvesSearchParams>

export const SHALLOW_SHELVES_DEFAULTS = {
  status: "approved" as const,
  pageIndex: 0,
  pageSize: 25,
}

export const applyShallowShelvesDefaults = (
  s: ShallowShelvesSearchValues,
): ShallowShelvesParams => ({
  status: s.status ?? SHALLOW_SHELVES_DEFAULTS.status,
  countryCodes: s.countryCodes,
  pageIndex: s.pageIndex ?? SHALLOW_SHELVES_DEFAULTS.pageIndex,
  pageSize: s.pageSize ?? SHALLOW_SHELVES_DEFAULTS.pageSize,
})

export const shallowShelvesQuery = (params: ShallowShelvesParams) =>
  queryOptions({
    queryKey: reportsQueryKeys.shallowShelves(params),
    queryFn: () => getShallowShelvesReport({ data: params }),
    placeholderData: keepPreviousData,
  })
